import http from '@/utils/http';

export default {
  async getById(id) {
    return await http.get(`/api/usuario_grupo/get/${id}`);
  },
  async insert(data) {
    return await http.post('/api/usuario_grupo/insert', data);
  },
  async update(data) {
    return await http.post('/api/usuario_grupo/update', data);
  },
  async delete(data) {
    return await http.post('/api/usuario_grupo/delete', data);
  }
};